<template>
  <div>
    <Title v-if="!isAdmin" :showMinister="true" :showService="true" />

    <Breadcrumb :links="breadCrumbData" />

    <Carrusel />
    <div class="container">
      <Button />
    </div>

    <section v-if="contenido">
      <!-- - Leyes y Normativas que rigen el funcionamiento de la Institución -->
      <!-- - Misión Institucional -->
      <TableTwo :contenido="contenido" />
      <!-- - Aspectos Relevantes contenidos en la Ley de Presupuestos año 2020 -->
      <TableFour :contenido="contenido" />
      <!-- - Objetivos Estratégicos -->
      <TableThree :contenido="contenido" />
      <!-- - Productos Estratégicos vinculados a Objetivos Estratégicos -->
      <TableFive :contenido="contenido" />
      <!-- - Clientes / Beneficiarios / Usuarios -->
      <TableOne :contenido="contenido" />
    </section>
    <section v-else>
      <AlertError />
    </section>
  </div>
</template>

<script>
import Title from "../../../components/private/Title";
import Breadcrumb from "@/components/tools/Breadcrumb.vue";
import Carrusel from "../../../components/private/Carrusel.vue";
import Button from "./Button.vue";
import { mapState } from "vuex";
import axiosClient from "@/config/axiosClient";
import TableOne from "./table/TableOne.vue";
import TableTwo from "./table/TableTwo.vue";
import TableThree from "./table/TableThree.vue";
import TableFour from "./table/TableFour.vue";
import TableFive from "./table/TableFive.vue";
import AlertError from "@/components/error/AlertError.vue";

export default {
  components: {
    Title,
    Carrusel,
    Breadcrumb,
    Button,
    TableOne,
    TableTwo,
    TableThree,
    TableFour,
    TableFive,
    AlertError,
  },
  computed: {
    ...mapState("sesion", ["usuario", "relacionUS"]),
    isAdmin: function() {
      return this.usuario.username === process.env.VUE_APP_USER_ADMIN;
    },
  },
  data() {
    return {
      permission: true,
      breadCrumbData: null,
      contenido: null,
    };
  },
  methods: {
    setBreadcrumbData: function() {
      this.breadCrumbData = [
        {
          name: "Portada BGI",
          routeName: "bgi",
          routeParams: {
            idUsuario: this.usuario.id,
          },
        },
        {
          name: "Escritorio de Gestión Virtual",
          routeName: "buttons",
          routeParams: {
            idUsuario: this.usuario.id,
            idServicio: this.$route.params.idServicio,
          },
        },
        {
          name: "Presentación del Servicio - Quiénes Somos",
          routeName: "somos",
          routeParams: {
            idServicio: this.$route.params.idServicio,
          },
        },
      ];
    },

    obtenerRelacionUsuarioServicio() {
      const relacionUs = this.usuario.servicios.find(
        (s) => s.id === this.$route.params.idServicio
      );
      if (!relacionUs) return;
      if (
        relacionUs.permisos.find((p) => p.permisoId === 8) ||
        relacionUs.rolId === 3 ||
        relacionUs.rolId === 4
      ) {
        this.permission = true;
      }
    },

    obtenerContenido: async function() {
      try {
        const res = await axiosClient.get(
          `/anexos/anexo/public_list/?anexo=1&servicio=${this.$route.params.idServicio}`
        );

        console.log(res);
        if (res.data[0]) {
          this.contenido =
            res.data[0].datos.modificado[`${process.env.VUE_APP_ANIO}`];
        }
        console.log("Desde el content", this.contenido);
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.setBreadcrumbData();
    this.obtenerContenido();
    this.obtenerRelacionUsuarioServicio();
  },
};
</script>
